// Derives the supplier from a deal id. Lives here rather than in entities/DealUtils so that
// dependency-free callers (analytics, RecheckAlternative) can share the one implementation
// without pulling in the Deal entity and its graph. DealUtils re-exports it unchanged.
function dealSupplierExtractor(deal) {
    const deal_id = deal && deal.id;
    if (!deal_id) {
        return {};
    }
    let supplier = deal_id.substr(0, 1); // backward compatible
    const splitted = deal_id.split(':');
    const supplier_hub_code = deal.supplier_hub_code;
    if (splitted.length > 1) {
        supplier = splitted[0];
    }
    if (supplier === 'H') {
        // backward compatible
        supplier = 'HB';
    }
    return { supplier, supplier_hub_code };
}

module.exports = { dealSupplierExtractor };
